import React from 'react';

import { Row, Col, Button } from 'antd';

export default function FormActions({
  onCancel,
  onSubmit,
}: {
  onCancel: () => void;
  onSubmit: () => void;
}) {
  return (
    <Row gutter={[16, 0]}>
      <Col>
        <Button size="large" onClick={onCancel}>
          Cancel
        </Button>
      </Col>
      <Col>
        <Button type="primary" size="large" onClick={onSubmit}>
          Save Compliance Item
        </Button>
      </Col>
    </Row>
  );
}
